//Please add the language resource
const delay = {
  msg:{
  }
};
export default delay



// WEBPACK FOOTER //
// ./src/page/report/delay/lang/delay.en.js